module.exports = __webpack_public_path__ + "img/Dodger2.ea3c77be.png";